export default __webpack_public_path__ + "static/media/269.440a3d62.png";